function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcon = function SvgIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M11.797 19.172a3.164 3.164 0 0 0-3.154 3.154 3.16 3.16 0 0 0 3.154 3.153h5.676c2.583 0 2.913 2.244 2.947 2.414l3.133 15.955.125.617s5.727 29.59 7.65 39.451c.033.17.582 7.494 9.115 7.494h58.354c8.62 0 8.892-6.301 9.117-7.494 1.797-9.537 7.512-38.09 7.512-38.09.033-.17.056-.45.052-.623 0 0-.08-3.978-1.394-5.576h-.002c-1.314-1.598-5.2-2.447-5.2-2.447a3.5 3.5 0 0 0-.622-.069l-78.215.026c-.174 0-.455.023-.627.05l-.61-.345a.87.87 0 0 1-.328-.483l-1.877-9.707c-.034-.17-.949-7.48-9.13-7.48h-4.625zM52.13 95.16c-4.102 0-7.44 3.336-7.44 7.438 0 4.101 3.338 7.44 7.44 7.44s7.437-3.339 7.437-7.44-3.335-7.438-7.437-7.438m35.074 0c-4.102 0-7.44 3.336-7.44 7.438 0 4.101 3.339 7.44 7.44 7.44s7.44-3.339 7.44-7.44-3.338-7.438-7.44-7.438",
    className: "icon_svg__black",
    style: {
      fill: "#2a508d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.54 47.787 65.988 65.339l-9.883-9.883-7.376 7.376 9.883 9.883 7.375 7.375 7.376-7.376 17.552-17.552z",
    className: "icon_svg__white",
    style: {
      fill: "#fff"
    }
  }));
};
export default SvgIcon;